module.exports = __webpack_public_path__ + "static/media/icons.448f2aaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/semantic/themes/default/assets/fonts/icons.svg
// module id = 4407
// module chunks = 0